var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoreBenefitsMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.5 22.7501C46.5086 26.0497 45.7377 29.3048 44.25 32.2501C42.4861 35.7794 39.7744 38.748 36.4186 40.8233C33.0629 42.8985 29.1956 43.9985 25.25 44.0001C21.9503 44.0087 18.6953 43.2377 15.75 41.7501L1.5 46.5001L6.25 32.2501C4.76233 29.3048 3.9914 26.0497 4 22.7501C4.00153 18.8045 5.10153 14.9372 7.1768 11.5814C9.25207 8.22569 12.2206 5.51399 15.75 3.75007C18.6953 2.2624 21.9503 1.49147 25.25 1.50007H26.5C31.7109 1.78755 36.6326 3.98697 40.3229 7.67722C44.0131 11.3675 46.2125 16.2892 46.5 21.5001V22.7501Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoreBenefitsMessage);
export default __webpack_public_path__ + "static/media/core-benefits-message.e776f319ac2b378582a989ac0f1e23cc.svg";
export { ForwardRef as ReactComponent };